/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobal = getGlobal;
function getGlobal() {
  return typeof globalThis !== 'undefined' ? globalThis : window;
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/getGlobal.js
// module id = 18
// module chunks = 0